// Module
var code = "<template class=\"i-tab tab-pane ${selected ? 'active show' : ''}\" id=\"${panelId}\" role=\"tabpanel\" aria-labelledby=\"${tabId}\"> <slot></slot> </template> ";
// Exports
export default code;